import { render, staticRenderFns } from "./loadedinventory.vue?vue&type=template&id=3bb53811&scoped=true&"
import script from "./loadedinventory.vue?vue&type=script&lang=js&"
export * from "./loadedinventory.vue?vue&type=script&lang=js&"
import style0 from "./loadedinventory.vue?vue&type=style&index=0&id=3bb53811&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bb53811",
  null
  
)

export default component.exports